import PeriodDateComponent from "./PeriodDateComponent";
import React from "react";
export const handlePeriodCurrentFilter = (
    periodCurrentFilter,
    attributeFilters,
    setAttributeFilters
) => {
    console.log('periodCurrentFilter===', periodCurrentFilter);
    if (periodCurrentFilter === 'period') {
        return (
            <PeriodDateComponent
                periodCurrentFilter={periodCurrentFilter}
                attributeFilters={attributeFilters}
                setAttributeFilters={setAttributeFilters}
            />
        )
    }
}